// Colors
export const colors = {
  // Supporting light and dark themes
  light: {
    defaultBorderColor: "#E1E1E1",
    lightBorderColor: "#F1F1F1",
    darkBorderColor: "#A1A1A1",
    backgroundColor: "#F5F6FA",
    defaultTextColor: "#353535",
    lightTextColor: "#9EA7CA",
    highlightColor: "#FFB17A",
  },
};

// Fonts
export const fonts = {
  family: {
    arial: "Arial",
  },
};
